<template>
  <div class="overflow-hidden" style="height: 100%;padding-left: 25px;">
    <!--设备告警-->
    <div style="padding-top: 15px;font-weight: bold;margin-bottom: 10px;">
      <span
          style="width: 5px;height: 15px;border-left: 2px solid #299FFB;display: inline-block;margin-bottom: -2px;margin-right: 5px;"></span>
      <span>设备告警</span>
    </div>
    <el-row class=" h-100 overflow" style="padding-left: 5px;">
      <el-col v-if="!alarmDevices || alarmDevices.length <= 0">
        <no-data style="margin-top: 15%"></no-data>
      </el-col>
      <el-col :key="index" :lg="21" :md="23" :sm="21" :xl="21" :xs="21"
              style="border-bottom: 1px solid rgba(41, 159, 251, .2);margin-top: 15px;"
              v-for="(item,index) in alarmDevices" @@touchstart.native="toRouter(item)"  @click.native="toRouter(item)">
        <el-col :lg="2" :md="2" :sm="2" :xl="2" :xs="2">
          <div
            style="height:22px;width:22px;border-radius: 50%;background-color: rgba(41, 159, 251, .2);text-align: center;margin-bottom: 3px;">
            {{ index + 1 }}
          </div>
        </el-col>
        <el-col :lg="11" :md="9" :sm="11" :xl="11" :xs="11" class="largeContent"
                style="margin-left: 10px;text-align: center">{{ item.name }}
        </el-col>
        <el-col :lg="4" :md="7" :sm="6" :xl="6" :xs="6" style="margin-left: 10px;">
          <span :style="{color: item.levelColor}">{{ item.levelName }}</span>
        </el-col>
        <el-col :lg="2" :md="2" :sm="2" :xl="2" :xs="2" style="margin-left: 10px;">
          <i :style="{color: item.levelColor}" class="el-icon-message-solid"></i>
        </el-col>
      </el-col>
    </el-row>
  </div>
</template>

<script>

import NoData from "@/components/NoData";
import {getAlarmDevices} from "@/network/device-info";
import platenLayoutEdit from '@/mixins/platenLayoutEdit'

export default {
  name: "DeviceAlarm",
  mixins: [platenLayoutEdit],
  components: {NoData},
  inject: ['overflow'],
  props: {
    spaceId: {
      type: String,
      default: () => null
    },
    tagId: {
      type: String,
      default: () => null
    }
  },
  watch: {
    spaceId: {
      handler() {
        this.getAlarmDevices()
      }
    },
    tagId() {
      this.getAlarmDevices()
    },
  },
  data() {
    return {
      alarmDevices: [],
      // 路由跳转
      router:'/realTime-alarm'
    }
  },
  methods: {
    getAlarmDevices() {
      getAlarmDevices(this.spaceId, this.tagId).then(res => {
        this.alarmDevices = []
        if (res.data) {
          this.alarmDevices = res.data
        }
      })
    },
    toRouter(item){
      if (this.isPlatenLayoutEditing) return
      // let routeUrl = this.$router.resolve({
      //   path: this.router,
      //   query: {spaceId: this.spaceId,id:item.alarmId}
      // });
      // console.log(routeUrl);
      // window.open(routeUrl.href, '_blank')
      this.$router.push({
        path: this.router,
        query: {spaceId: this.spaceId,id:item.alarmId}
      })
    }
  },
  mounted() {
    this.overflow()
    this.getAlarmDevices()
  },
  created() {
    this.$store.dispatch('addIntervalObj', {'getAlarmDevices:4000': this.getAlarmDevices})
  },
  destroyed() {
    this.$store.dispatch('removeIntervalObj', 'getAlarmDevices')
  }
}
</script>

<style scoped>

</style>
